import React from 'react';
import { object, string } from 'prop-types';
import CheckoutCta from '../../../../shared/CheckoutCta';
import LimitedEdition from './LimitedEdition';

const CtaBtn = ({ className, price }, { general }) => {
    const { isLimitedEdition } = general;

    return (
        <>
            {isLimitedEdition ? <LimitedEdition/> : <CheckoutCta className={className} price={price}/>}
        </>
    );
};

CtaBtn.propTypes = {
    className: string,
    price: string
};

CtaBtn.contextTypes = {
    general: object
};

export default CtaBtn;
